import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";

export default function CricketWidget() {
  const [showWidgetButton, setShowWidgetButton] = useState(true);
  const [timer, setTimer] = useState(false);
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const cricketWidgetConfig = qtState?.data?.frontendConfig?.cricketWidgetConfig;

  if (!cricketWidgetConfig?.enabled) {
    return null;
  }
  const avoidUrl = cricketWidgetConfig?.avoidUrl;

  setTimeout(() => {
    setTimer(true);
  }, 3000);

  useEffect(() => {
    if (window?.location?.pathname === avoidUrl) {
      setShowWidgetButton(false);
    }
    const cricketDataUrl = "https://www.deccanherald.com/custom-widget-json";
    const refreshIntervalMs = 10000;

    let lastLine1 = null;
    let lastLine2 = null;
    let lastParsedScore = null;
    let isAnimatingScoreEvent = false;
    let refreshTimerId = null;

    const widgetEl = document.getElementById("cricket-pill-widget");
    const closeBtn = document.getElementById("cricket-pill-close");

    if (widgetEl) {
      widgetEl.addEventListener("click", () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "cricket_widget_click",
          page_url: window.location.href
        });
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        const wrapper = document.getElementById("cricket-widget-wrapper");
        if (wrapper) wrapper.style.display = "none";
        if (refreshTimerId) clearInterval(refreshTimerId);
      });
    }

    function animateLineChange(el) {
      if (!el) return;
      el.classList.remove("line-flash");
      void el.offsetWidth;
      el.classList.add("line-flash");
    }

    function parseScoreLine(line) {
      if (typeof line !== "string") return null;
      const match = line.match(/(\d+)\s*\/\s*(\d+)/);
      if (!match) return null;
      return {
        runs: parseInt(match[1], 10),
        wickets: parseInt(match[2], 10)
      };
    }

    function setScoreTextImmediate(el, newText) {
      if (!el) return;
      el.textContent = newText;
      lastLine2 = newText;
    }

    function triggerScoreEventAnimation(line2El, type, delta, onComplete) {
      const badgeEl = document.getElementById("cricket-score-event");
      const statusEl = document.querySelector(".cricket-pill-status");

      if (!badgeEl || !line2El) {
        onComplete && onComplete();
        return;
      }

      badgeEl.className = "score-event-badge";
      statusEl && statusEl.classList.add("show-event");

      if (type === "wicket") {
        badgeEl.textContent = "W";
        badgeEl.classList.add("is-wicket", "animate-wicket");
      } else {
        badgeEl.textContent = `+${delta}`;
        badgeEl.classList.add("is-runs", "animate-runs");
      }

      line2El.classList.remove("score-impact", "score-wicket");
      void line2El.offsetWidth;
      line2El.classList.add(
        type === "wicket" ? "score-wicket" : "score-impact"
      );

      setTimeout(() => {
        badgeEl.className = "score-event-badge";
        statusEl && statusEl.classList.remove("show-event");
        onComplete && onComplete();
      }, 2000);
    }

    function setRollingText(el, newText, onComplete) {
      if (!el) return;

      if (lastLine2 === null) {
        el.textContent = newText;
        lastLine2 = newText;
        onComplete && onComplete();
        return;
      }

      if (newText === lastLine2) return;

      const safeOld = lastLine2;

      el.innerHTML = `
        <span class="score-roll-inner">
          <span class="score-roll-row">${safeOld}</span>
          <span class="score-roll-row">${newText}</span>
        </span>
      `;

      const inner = el.querySelector(".score-roll-inner");
      if (inner) {
        void inner.offsetWidth;
        inner.classList.add("roll");
      }

      setTimeout(() => {
        el.textContent = newText;
        lastLine2 = newText;
        onComplete && onComplete();
      }, 500);
    }

    function setUpdatingState(isUpdating) {
      const widget = document.getElementById("cricket-pill-widget");
      if (widget) widget.classList.toggle("is-updating", isUpdating);
    }

    function updateCricketWidget(data) {
      if (!data) return;

      setUpdatingState(false);

      const line1 = typeof data.line1 === "string" ? data.line1 : "---";
      const line2 = typeof data.line2 === "string" ? data.line2 : "--";

      const line1El = document.getElementById("cricket-pill-line1");
      const line2El = document.getElementById("cricket-pill-line2");

      if (line1El && (lastLine1 === null || line1 !== lastLine1)) {
        line1El.innerText = line1;
        animateLineChange(line1El);
        lastLine1 = line1;
      }

      if (!line2El) return;

      const parsedScore = parseScoreLine(line2);

      if (lastLine2 === null) {
        setScoreTextImmediate(line2El, line2);
        lastParsedScore = parsedScore;
        return;
      }

      if (line2 === lastLine2) return;

      if (!isAnimatingScoreEvent && parsedScore && lastParsedScore) {
        const runsDelta = parsedScore.runs - lastParsedScore.runs;
        const wicketsDelta = parsedScore.wickets - lastParsedScore.wickets;

        if (wicketsDelta > 0 || runsDelta > 0) {
          isAnimatingScoreEvent = true;
          triggerScoreEventAnimation(
            line2El,
            wicketsDelta > 0 ? "wicket" : "runs",
            wicketsDelta || runsDelta,
            () => {
              setScoreTextImmediate(line2El, line2);
              lastParsedScore = parsedScore;
              isAnimatingScoreEvent = false;
            }
          );
          return;
        }
      }

      setRollingText(line2El, line2, () => {
        if (parsedScore) lastParsedScore = parsedScore;
      });
    }

    function fetchCricketData() {
      const url = `${cricketDataUrl}?_ts=${Date.now()}`;
      fetch(url, { cache: "no-store" })
        .then(res => res.json())
        .then(updateCricketWidget)
        .catch(() => setUpdatingState(true));
    }

    fetchCricketData();
    refreshTimerId = setInterval(fetchCricketData, refreshIntervalMs);

    return () => {
      if (refreshTimerId) clearInterval(refreshTimerId);
    };
  }, []);

   return (
    <>
      <style>{`
         @import url('https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@500;600;700&display=swap');

        :root {
            --cricket-pill-width: 175px;
            --cricket-pill-width-mobile: 175px;
        }

        * {
            box-sizing: border-box;
        }

        html, body {
            margin: 0;
            padding: 0;
        }

        body {
            font-family: "Roboto Slab", serif;
            background: transparent;
        }

        .cricket-widget-wrapper {
            font-family: "Roboto Slab", serif;
        }

        .cricket-widget-wrapper {
            position: fixed;
            right: 24px;
            bottom: 100px;
            z-index: 1205;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: 12px;
            pointer-events: none;
        }

        .cricket-widget-wrapper * {
            pointer-events: auto;
        }

        .cricket-pill-widget {
            background:
                linear-gradient(0deg, rgba(9, 18, 10, 0.5), rgba(9, 18, 10, 0.5)),
                url('https://quintype-dropbox.s3-accelerate.amazonaws.com/deccanherald.quintype.com/2026-02-02/vdgrzllz/green_grass_pattern_texture_soccer_field_background_football_86137160.webp');
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            color: #f8fafc;
            padding: 12px 12px;
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            min-height: 60px;
            border: 1px solid rgba(248, 250, 252, 0.16);
            cursor: pointer;
            min-width: var(--cricket-pill-width);
            position: relative;
            overflow: hidden;
        }

        .cricket-pill-left {
            display: flex;
            align-items: flex-start;
            gap: 6px;
            flex-direction: column;
            height: 100%;
            justify-content: center;
            flex: 1;
            min-width: 0;
        }

        .cricket-pill-widget.is-updating .cricket-pill-top {
            display: none;
        }

        .cricket-pill-widget.is-updating .cricket-pill-left {
            align-items: center;
        }

        .cricket-pill-widget.is-updating .cricket-pill-bottom {
            justify-content: center;
            width: 100%;
        }

        .cricket-pill-widget::after {
            content: "";
            position: absolute;
            inset: 0;
            background:
                radial-gradient(circle at top left, rgba(255, 255, 255, 0.18), transparent 55%),
                linear-gradient(0deg, rgba(0, 0, 0, 0.24), rgba(0, 0, 0, 0.06));
            opacity: 0.6;
            pointer-events: none;
        }

        .cricket-ball-icon {
            width: 24px;
            height: 24px;
            display: block;
        }

        .cricket-pill-close {
            position: absolute;
            top: -35px;
            right: 0;
            width: 30px;
            height: 30px;
            border-radius: 999px;
            border: none;
            background: rgba(15, 23, 42, 0.85);
            color: #fff;
            font-size: 14px;
            line-height: 1;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
        }

        .cricket-pill-close:hover {
            background: rgba(15, 23, 42, 1);
        }

        .cricket-pill-close:focus-visible {
            outline: 2px solid #fff3b0;
            outline-offset: 2px;
        }

        .cricket-pill-status {
            position: relative;
            width: 34px;
            height: 22px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
        }

        .cricket-pill-status.show-event .cricket-ball-icon {
            opacity: 0;
            transform: scale(0.6);
        }

        .cricket-pill-top {
            display: flex;
            align-items: center;
            gap: 6px;
            font-size: 13px;
            font-weight: 700;
            letter-spacing: 0.4px;
            justify-content: flex-start;
            width: 100%;
            text-transform: uppercase;
            color: #f8fafc;
            text-shadow: 0 1px 3px rgba(0, 0, 0, 0.7);
        }

        .cricket-pill-bottom {
            display: flex;
            align-items: baseline;
            gap: 6px;
            font-size: 13px;
            font-weight: 700;
            justify-content: flex-start;
            width: 100%;
            color: #f8fafc;
            text-shadow: 0 1px 3px rgba(0, 0, 0, 0.7);
        }

        .cricket-pill-bottom strong,
        .cricket-pill-bottom span {
            font-family: "Roboto Slab", serif;
        }

        .cricket-pill-bottom strong {
            color: #ffe08a;
            text-shadow: 0 0 10px rgba(0, 0, 0, 0.6);
        }

        .cricket-pill-widget.is-updating .cricket-pill-bottom strong {
            color: #f8fafc;
        }

        .score-event-badge {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            opacity: 0;
            padding: 3px 8px;
            border-radius: 6px;
            font-size: 12.5px;
            font-weight: 800;
            letter-spacing: 0.2px;
            text-transform: uppercase;
            white-space: nowrap;
            box-shadow: 0 6px 12px rgba(0, 0, 0, 0.4);
            pointer-events: none;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            line-height: 1;
            min-width: 28px;
        }

        .score-event-badge.is-runs {
            background: #ffffff;
            color: #111827;
            border: 1px solid rgba(0, 0, 0, 0.16);
            box-shadow: 0 6px 14px rgba(0, 0, 0, 0.28);
        }

        .score-event-badge.is-runs::before {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 3px;
            background: #22c55e;
            border-radius: 6px 0 0 6px;
        }

        .score-event-badge.is-wicket {
            background: linear-gradient(135deg, #ef4444, #b91c1c);
            color: #fff;
            border: 1px solid rgba(255, 255, 255, 0.4);
        }

        .score-event-badge.animate-runs {
            animation: scoreRunsFly 2s ease-out;
        }

        .score-event-badge.animate-wicket {
            animation: scoreWicketSmash 2s ease-out;
        }

        .score-roll {
            position: relative;
            display: inline-block;
            overflow: hidden;
            height: 1.2em;
            line-height: 1.2em;
        }

        .score-roll-inner {
            display: block;
            transform: translateY(0);
        }

        .score-roll-inner.roll {
            animation: scoreRoll 0.45s ease-in-out forwards;
        }

        .score-roll-row {
            display: block;
            height: 1.2em;
            line-height: 1.2em;
        }

        .score-impact {
            animation: scoreImpact 0.45s ease-in-out;
        }

        .score-wicket {
            animation: scoreWicket 0.6s ease-in-out;
        }

        @keyframes scoreRoll {
            from { transform: translateY(0); }
            to { transform: translateY(-100%); }
        }

        @keyframes scoreRunsFly {
            0% { opacity: 0; transform: translate(calc(-50% + 14px), -50%) scale(0.85); }
            10% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
            70% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
            100% { opacity: 0; transform: translate(calc(-50% - 8px), -50%) scale(0.9); }
        }

        @keyframes scoreWicketSmash {
            0% { opacity: 0; transform: translate(calc(-50% + 14px), -50%) scale(0.85) rotate(-6deg); }
            10% { opacity: 1; transform: translate(-50%, -50%) scale(1) rotate(0deg); }
            70% { opacity: 1; transform: translate(-50%, -50%) scale(1) rotate(0deg); }
            100% { opacity: 0; transform: translate(calc(-50% - 8px), -50%) scale(0.92) rotate(2deg); }
        }

        @keyframes scoreImpact {
            0% { transform: translateY(0); }
            30% { transform: translateY(-2px); }
            60% { transform: translateY(1px); }
            100% { transform: translateY(0); }
        }

        @keyframes scoreWicket {
            0% { transform: translateX(0); }
            25% { transform: translateX(-1px); }
            50% { transform: translateX(2px); }
            75% { transform: translateX(-2px); }
            100% { transform: translateX(0); }
        }

        .line-flash {
            animation: lineFlash 0.4s ease-in-out;
        }

        @keyframes lineFlash {
            0% { transform: translateY(0); opacity: 1; }
            50% { transform: translateY(-2px); opacity: 0.6; }
            100% { transform: translateY(0); opacity: 1; }
        }


        @media (max-width: 767px) {
            .cricket-widget-wrapper {
                left: auto;
                right: 12px;
                bottom: 170px;
                align-items: flex-end;
            }

            .cricket-pill-widget {
                width: var(--cricket-pill-width-mobile);
                min-width: 0;
                padding: 10px 12px;
                border-radius: 20px;
                min-height: 52px;
            }

            .cricket-pill-top,
            .cricket-pill-bottom {
                font-size: 13px;
                font-weight: 800;
            }

            .score-event-badge {
                font-size: 11px;
                padding: 2px 6px;
                min-width: 24px;
            }

            .cricket-pill-status {
                width: 28px;
                height: 20px;
            }

            .cricket-pill-close {
                width: 24px;
                height: 24px;
                font-size: 12px;
                top: -25px;
                right: 0;
            }
        }
      `}</style>

      {timer && showWidgetButton && (<div id="cricket-widget-wrapper" className="cricket-widget-wrapper">
       <button
          id="cricket-pill-close"
          className="cricket-pill-close"
          type="button"
          aria-label="Close cricket widget"
          onClick={() => {
            const wrapper = document.getElementById("cricket-widget-wrapper");
            if (wrapper) wrapper.style.display = "none";
          }}
        >
          ×
        </button>

        <a href={cricketWidgetConfig?.landingUrl || "#"}><div
          id="cricket-pill-widget"
          className="cricket-pill-widget"
          aria-live="polite"
        >
          <div className="cricket-pill-left">
            <div className="cricket-pill-top">
              <span id="cricket-pill-line1">Loading...</span>
            </div>

            <div className="cricket-pill-bottom">
              <strong
                id="cricket-pill-line2"
                className="score-roll"
              >
                --
              </strong>
            </div>
          </div>

          <div className="cricket-pill-status" aria-hidden="true">
            <svg
              id="cricket-live-dot"
              className="cricket-ball-icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              role="img"
              aria-label="Cricket ball icon"
            >
              <defs>
                <clipPath id="cricket-ball-clip">
                  <circle cx="256" cy="256" r="220" />
                </clipPath>
              </defs>

              <g>
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="0 256 256"
                  to="360 256 256"
                  dur="6s"
                  repeatCount="indefinite"
                />

                <circle cx="256" cy="256" r="220" fill="#b5162f" />

                <g clipPath="url(#cricket-ball-clip)">
                  <circle cx="270" cy="270" r="210" fill="#8f0f25" opacity="0.55" />
                  <circle cx="210" cy="210" r="120" fill="#d9445b" opacity="0.35" />
                </g>

                <g
                  clipPath="url(#cricket-ball-clip)"
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                >
                  <path
                    d="M210 20 C260 150, 260 362, 210 492"
                    strokeWidth="18"
                    strokeDasharray="12 26"
                  />
                  <path
                    d="M302 20 C352 150, 352 362, 302 492"
                    strokeWidth="18"
                    strokeDasharray="12 26"
                  />
                  <path
                    d="M238 10 C288 150, 288 362, 238 502"
                    strokeWidth="16"
                  />
                  <path
                    d="M274 10 C324 150, 324 362, 274 502"
                    strokeWidth="16"
                  />
                </g>
              </g>
            </svg>

            <span
              id="cricket-score-event"
              className="score-event-badge"
            />
          </div>
        </div></a>
      </div>)}

    </>
  );
}
